"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COUNTRIES_USING_12_HOUR_FORMAT = void 0;
exports.COUNTRIES_USING_12_HOUR_FORMAT = [
    "au",
    "bd",
    "ca",
    "co",
    "eg",
    "in",
    "ie",
    "jo",
    "my",
    "mx",
    "nz",
    "ni",
    "pk",
    "ph",
    "sa",
    "us",
];
//# sourceMappingURL=countriesUsing12HourFormat.js.map